import logo from '../Assets/Img/Logo.png';
import './Header.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';

function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <header className="header-plataforma">
            <div className="header-contenedor">
                {/* Logo */}
                <div className="logoo">
                    <img src={logo} className="logoo-img" alt="Tresatec" />
                </div>

                {/* Navegación */}
                <nav className={`nav ${isOpen ? 'open' : ''}`}>
                    <ul className="nav-list">
                        <li>
                            <Link to="/" className="nav-pill" onClick={closeMenu}>
                                Inicio
                            </Link>
                        </li>
                        <li>
                            <Link to="/AboutUs" className="nav-pill" onClick={closeMenu}>
                                Sobre nosotros
                            </Link>
                        </li>
                        <li>
                            <Link to="/Servicios" className="nav-pill" onClick={closeMenu}>
                                Módulos
                            </Link>
                        </li>
                        <li>
                            <Link to="/Contactos" className="nav-pill" onClick={closeMenu}>
                                Contacto
                            </Link>
                        </li>
                    </ul>

                    {/* CTAs */}
                    <div className="nav-cta">
                        <Link to="/PlataformaEducativa" className="nav-pill secondary" onClick={closeMenu}>
                            ← Conocer Tresaedu
                        </Link>

                        <a
                            href="https://wa.me/message/ORWIOZ4UP74NM1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-pill cta"
                            onClick={closeMenu}
                        >
                            Solicitar demo
                        </a>
                    </div>
                </nav>

                {/* Menú Hamburguesa (solo visible en móviles) */}
                <div 
                    className={`hamburger ${isOpen ? 'open' : ''}`} 
                    onClick={toggleMenu}
                >
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </div>
        </header>
    );
}

export default Header;